<template>
	<div>
		<firstsceenimage :imgobj='bigimage'></firstsceenimage>
		<adword v-if="isShowNavAD" :backimg="adimg">
			<div style=" color: white; height: 380px;width: 70%;margin-left: auto;margin-right: auto;">
				<div style="display: flex; justify-content:  space-between;text-align: left;margin-top: 150px;">
					<div style="width: 338px;">
						<div style="font-size: 24px;line-height: 32px;letter-spacing: 4px;font-weight: bold;">
							全球流行趋势分析</br>商品企划数字化</div>
						<div
							style="font-size: 12px;opacity: 0.8;margin-top: 14px;line-height: 18px;letter-spacing: 2px;">
							星链基于高品质的数据整合以及覆盖到SKU级的详尽数据，对行业、竞店、类目及属性进行大数据分析，解读趋势，赋能行业上下游。</div>
					</div>

					<div style="width: 338px;">
						<div style="font-size: 24px;line-height: 32px;letter-spacing: 4px;font-weight: bold;">
							鞋款研发数字化</br>
							极速高效的设计能力</div>
						<div
							style="font-size: 12px;opacity: 0.8;margin-top: 14px;line-height: 18px;letter-spacing: 2px;">
							星链建设企业专属楦标准后身库与净样版模组库，并通过CAD软件实现3D鞋款设计与2D开版联通，实现鞋款快速设计。</div>
					</div>

					<div style="width: 338px;">
						<div style="font-size: 24px;line-height: 32px;letter-spacing: 4px;font-weight: bold;">
							柔性生产小单快反</br>
							提升选款决策效率</div>
						<div
							style="font-size: 12px;opacity: 0.8;margin-top: 14px;line-height: 18px;letter-spacing: 2px;">
							星链利用AI趋势分析系统和鞋款数字化研发系统，以及严格的供应链准入机制和智能订单分派系统，做到7天快反、24小时打样排产，打造高品质、低价格柔性供应体系。</div>
					</div>
				</div>

			</div>
		</adword>
		<div v-if="isShowNavAD" ref="liuchengimgref">
			<adword :style="{backgroundImage: 'url('+backimg+') ' }"
				style="background-repeat:no-repeat;background-position:left bottom ; background-color:#F8F8F8 ;"
				title="全程可视化柔性供应链" subtitle="供应链专家全程服务，无缝跟单。给客户“全感视角”，借助信息技术，将业务流程全程透明化。" viewheight="590">
				<div>

					<div>
						<transition name="adfadex2">
							<img v-if="liuchengimgshow" style="" src="../static/设计打样.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="liuchengimgshow" style="margin-left: 150px; " src="../static/分配最优供应商ico.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="liuchengimgshow" style="margin-left: 150px;" src="../static/质检与发货.png" />
						</transition>
						<transition name="adfadex5">
							<img v-if="liuchengimgshow" style="margin-left: 150px;" src="../static/售后服务ico.png" />
						</transition>

					</div>

					<div style="text-align: left;">
						<img v-if="liuchengimgshow" :class="[liuchengimgshow?'adfadew1':'']"
							style="margin-left: 340px; width: 60%;height: 17px;" src="../static/轴承ico3.png">
					</div>


					<div>
						<transition name="adfadex2">
							<img v-if="liuchengimgshow" style="" src="../static/数据资料ico.png" />
						</transition>
						<transition name="adfadex3">
							<img v-if="liuchengimgshow" style="margin-left: 190px;" src="../static/供应链下单.png" />
						</transition>
						<transition name="adfadex4">
							<img v-if="liuchengimgshow" style="margin-left: 190px;" src="../static/全程可视化ico.png" />
						</transition>
						<transition name="adfadex5">
							<img v-if="liuchengimgshow" style="margin-left: 190px;" src="../static/云仓物流ico.png" />
						</transition>
					</div>
				</div>

			</adword>
		</div>

		<adword title="专业团队顶级赋能" slotheight="580">
			<div>
				<img class="supplyimage1"   src="../static/专业团队顶级赋能.gif" />
			</div>
		</adword>
		<adword title="柔性供应链的多用户场景"
			subtitle="星链柔性供应链服务，为品牌客户、设计师、主播达人、MCN机构、时尚买手等提供从趋势设计、选款试销、预售订货，到订单管理、报价生产、交付结算的 柔性供应链服务。" viewheight="780">
			<div class="flexcenter" style="margin-top: 30px;">
				<div @mouseenter="swimg2(0)"
					style="position: relative;width:347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width:347px;height:473px;">
							<div style="text-align: center;">
								<div style=" font-size: 36px;letter-spacing: 5px; font-weight: bold;">丰富的<br>品牌商</div>
								<div
									style="margin-top: 10px; font-size: 12px;opacity: 0.3;letter-spacing:18px;text-transform :uppercase;">
									BRAND
								</div>
							</div>
						</div>
					</div>
					<img :class="[swimgbool2[0]?'imgscale':'']" style="width:347px;height:473px;z-index: 1;"
						src="../static/丰富品牌商.png">
				</div>
				<div style="width: 10px;height: 1px;"></div>

				<div @mouseenter="swimg2(1)"
					style="position: relative; width:347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width:347px;height:473px;">
							<div style="text-align: center;">
								<div style=" font-size: 36px;letter-spacing: 5px; font-weight: bold;">生产<br>
									工厂</div>
								<div
									style="margin-top: 10px; font-size: 12px;opacity: 0.3;letter-spacing:15px;text-transform :uppercase;">
									PRODUCTION
								</div>
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[1]?'imgscale':'']" style="width:347px;height:473px;z-index: 1;"
						src="../static/生产工厂.png">
				</div>
				<div style="width: 10px;height: 1px;"></div>

				<div @mouseenter="swimg2(2)"
					style="position: relative;width:347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;">
						<div class="cc" style="width:347px;height:473px;">
							<div style="text-align: center;">
								<div style=" font-size: 36px;letter-spacing: 5px; font-weight: bold;">MCN<br>
									网红电商</div>
								<div
									style="margin-top: 10px; font-size: 12px;opacity: 0.3;letter-spacing:11px;text-transform :uppercase;">
									online retailers

								</div>
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[2]?'imgscale':'']" style="width:347px;height:473px;z-index: 1;"
						src="../static/mcn网红电商.png">
				</div>
				<div style="width: 10px;height: 1px;"></div>

				<div @mouseenter="swimg2(3)"
					style="position: relative; width:347px;height:473px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;color: white;z-index: 2;">
						<div class="cc" style=" width:347px;height:473px;">
							<div style="text-align: center;">
								<div style=" font-size: 36px;letter-spacing: 5px; font-weight: bold;">团定<br>
									客户</div>
								<div
									style="margin-top: 10px; font-size: 12px;opacity: 0.3;letter-spacing:15px;text-transform :uppercase;">
									customer
								</div>
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[3]?'imgscale':'']" style="width:347px;height:473px;z-index: 1;"
						src="../static/团订客户.png">
				</div>


			</div>
			<div
				style="margin-left: auto;margin-right: auto;  margin-top: 50px;color: #999999;line-height: 32px;border: 1px solid #999999;width: 90px;height: 32px;">
				联系我们></div>
		</adword>
	</div>
</template>

<script>
	import firstsceenimage from '../components/firstsceenimage.vue'
	import adword from '../components/adword.vue'
	import bigimage from '../static/星链数据柔性供应链.png'
	import adimg from '../static/柔性供应bg.png'
	import backimg from '../static/星链鞋履供应链解决方案水印.png'

	export default {
		name: 'Supply',
		components: {
			firstsceenimage,
			adword,
			adimg,
		},
		data() {
			return {
				bigimage: bigimage,
				adimg: adimg,
				backimg: backimg,

				swimgbool2: [false, false, false, false],
				liuchengimgtop: 0,
				liuchengimgshow: false,
				isShowNavAD: true,
			}
		},
		mounted() {

			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			this.liuchengimgtop = this.$refs.liuchengimgref.offsetTop
			if (window.innerWidth < 1000) {
				this.isShowNavAD = false
			}

		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示4ad
				if (!this.liuchengimgshow) {
					if (this.vscrolltop > this.liuchengimgtop) {
						this.liuchengimgshow = true;

					}
				}

			},


			swimg2: function(index) {
				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool2[index]) {
							this.$set(this.swimgbool2, index, true)
						}
					} else {
						this.$set(this.swimgbool2, i, false)
					}
				}

			},
		},

	}
</script>

<style>
	
	@media (min-width: 1px) {
	 .supplyimage1{
		 height: 60%;
		 width: 60%;
	 }  
	 }
	 
	@media (min-width: 1000px) {
	 .supplyimage1{
		 height: 480px;
		 width: 480px;
	 }  
	 }
	
	/* adfadex2 在index这个页面 */
	.adfadex3-enter-active {
		transition: all 1s;
	}

	.adfadex3-enter {
		opacity: 0;
		transform: translateX(80px);
	}

	.adfadex4-enter-active {
		transition: all 1s;
	}

	.adfadex4-enter {
		opacity: 0;
		transform: translateX(140px);
	}

	.adfadex5-enter-active {
		transition: all 1s;
	}

	.adfadex5-enter {
		opacity: 0;
		transform: translateX(180px);
	}

	.adfadew1 {

		animation-name: adfadew1d;
		animation-duration: 1s;
	}

	@keyframes adfadew1d {
		0% {
			opacity: 0;
			width: 70%;
		}

		100% {
			opacity: 1;
			width: 60%;
		}
	}
</style>
